import { useState } from 'react'

import { useEffect } from 'react'
import type { PlayerDimensions } from '../index.h'

export const usePlayerDimensions = (
  url: string,
  playerContainer: HTMLDivElement | null
) => {
  const [dimensions, setDimensions] = useState<PlayerDimensions>({
    width: 0,
    height: 0,
  })

  useEffect(() => {
    if (playerContainer) {
      const { width, height } = playerContainer.getBoundingClientRect()
      setDimensions({ width, height })
    }
  }, [url, playerContainer])

  return dimensions
}
